module.exports = __webpack_public_path__ + "img/symbol_4.ab5f29ba.png";